import React, { useEffect, useState } from 'react';
import { TableHeaderColumn } from "react-bootstrap-table";
import { months } from '../../../../Utils/months';
import GridEmpty from '../../../../Utils/Grid/GridEmpty';
import { columnaClaseFija, columnaFijaTotales } from '../../../../../../utility/staticColumns';

// Función para formatear números negativos entre paréntesis
const formatCurrency = (value, currency) => {
    if (value === null || value === undefined || isNaN(value)) {
        return '';
    }
    
    const absValue = Math.abs(value);
    const formatted = currency === 'USD'
        ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(absValue)
        : new Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(absValue);
    
    // Todos los valores de inversión son salidas (negativos)
    return `(${formatted})`;
};

const List = props => {
    const { data, loader, onSortChange, currency } = props;

    const dataExportable = data && data.investments && Array.isArray(data.investments.results) ? data.investments.results : [];

    const [collapsed, setCollapsed] = useState(false);

    const handleCollapseTable = (e) => {
        setCollapsed(!collapsed);
    };

    useEffect(() => {
        // Seleccionamos los encabezados de la tabla
        const headers = document.querySelectorAll(".investment-flow thead");

        // Agregamos el evento a cada uno
        headers.forEach((header) => {
            header.addEventListener("click", handleCollapseTable);
        });

        // Cleanup para evitar duplicados al desmontar
        return () => {
            headers.forEach((header) => {
                header.removeEventListener("click", handleCollapseTable);
            });
        };
    }, [handleCollapseTable]);

    const formatearNumero = (dato) => {
        return <span style={{ color: '#dc3545', fontWeight: '500' }}>
            {formatCurrency(dato, currency)}
        </span>;
    }
    
    const columnaClaseTotal = (cell, row) => {
        if (row.name === 'TOTALES') {
            return 'celda-totales';
        }
        return '';
    };

    const meses = months
    const columnas = meses.map((mes, index) => (
        <TableHeaderColumn
            key={index}
            dataField={mes}
            dataSort
            dataFormat={formatearNumero}
            columnClassName={columnaClaseTotal}
            width='130'
            dataAlign='right'
            headerAlign='right'
        >
            {index + 1}
        </TableHeaderColumn>
    ));


    return (
        <GridEmpty
            hover
            striped
            data={!collapsed ? dataExportable : dataExportable.slice(-1)}
            loading={loader}
            onSortChange={onSortChange}
            pagination={false}
            className="pb-3 investment-flow"
        >

            <TableHeaderColumn
                dataField="name"
                isKey={true}
                dataSort
                className="table-fixed-cell-left-0"
                columnClassName={columnaClaseFija}
                width='170'
                tdStyle={{ whiteSpace: 'normal', color: '#dc3545', fontWeight: '500' }}
            >
                FLUJO DE INVERSIÓN
            </TableHeaderColumn>
            <TableHeaderColumn
                dataField="total"
                dataSort
                dataFormat={formatearNumero}
                width='160'
                className="table-fixed-cell-left-1"
                columnClassName={columnaFijaTotales}
                dataAlign='right'
                headerAlign='right'
            >
                Total
            </TableHeaderColumn>
            {columnas}

        </GridEmpty>
    );
};
export default List;
